import { render, staticRenderFns } from "./serviceAgreement.vue?vue&type=template&id=4c728bf5&scoped=true"
import script from "./serviceAgreement.vue?vue&type=script&lang=js"
export * from "./serviceAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c728bf5",
  null
  
)

export default component.exports